module.exports = __webpack_public_path__ + "static/media/check-with-circle.2ac95d15.png";